import { materialsOverspendAPI } from "@/views/MaterialsOverspend/services/api";

export const getSmetaMaterialsOverspend = async (params) => {
  try {
    const res = await materialsOverspendAPI.getSmetaMaterialsOverspend(params);
    return res?.data;
  } catch (e) {}
};

export const materialsOverspendColumns = [
  {
    name: "material_name",
    field: "material_name",
    label: "Материал",
    align: "left",
    sortable: true,
    style: "min-width: 220px",
  },
  {
    name: "material_unit_name",
    field: "material_unit_name",
    label: "Ед. изм.",
    align: "left",
    sortable: true,
    style: "width: 100px",
  },
  {
    name: "smeta_cnt",
    field: "smeta_cnt",
    label: "В смете",
    align: "right",
    sortable: true,
    style: "width: 140px",
  },
  {
    name: "ordered_cnt",
    field: "ordered_cnt",
    label: "Заказано",
    align: "right",
    sortable: true,
    style: "width: 120px",
  },
  {
    name: "overspend_cnt",
    field: "overspend_cnt",
    label: "Перерасход",
    align: "right",
    sortable: true,
    style: "width: 140px",
  },
  {
    name: "smeta_sum",
    field: "smeta_sum",
    label: "В смете",
    align: "right",
    sortable: true,
  },
  {
    name: "ordered_sum",
    field: "ordered_sum",
    label: "Заказано",
    align: "right",
    sortable: true,
  },
  {
    name: "overspend_sum",
    field: "overspend_sum",
    label: "Перерасход",
    align: "right",
    sortable: true,
  },
];
